import { dashboardApi } from '@/store/api/base/api.base';
import { writeMail } from '@/store/api/mail/mail.cache';
import type { TypeMail, TypeMailInput, TypeMailSendKind, TypeMailTarget } from '@/types/mail/types.mail';

export const LIMIT = 20;

const targetKey = (target: TypeMailTarget): string => ('quoteId' in target ? `quote:${target.quoteId}` : `invoice:${target.invoiceId}`);

const PATHS: Record<TypeMailSendKind, (id: string) => string> = {
    quote: (id) => `/quotes/${id}/send`,
    invoice: (id) => `/invoices/${id}/send`,
    reminder: (id) => `/invoices/${id}/remind`,
};

export const mailApi = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        listMails: build.query<TypeMail[], TypeMailTarget>({
            query: (target) => ({ url: '/mails', params: { ...target, limit: LIMIT } }),
            transformResponse: (response: { items?: TypeMail[] }) => (Array.isArray(response?.items) ? response.items : []),
            providesTags: (_result, _error, target) => [{ type: 'Mail', id: targetKey(target) }],
        }),

        sendMail: build.mutation<TypeMail, { kind: TypeMailSendKind; id: string; mail: TypeMailInput; clientRef: string }>({
            query: ({ kind, id, mail, clientRef }) => ({ url: PATHS[kind](id), method: 'post', data: { mail, clientRef } }),
            onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    writeMail(dispatch, data);
                } catch {
                    return;
                }
            },
        }),

        retryMail: build.mutation<TypeMail, string>({
            query: (id) => ({ url: `/mails/${id}/retry`, method: 'post' }),
            onQueryStarted: async (_id, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    writeMail(dispatch, data);
                } catch {
                    return;
                }
            },
        }),
    }),
});

export const { useListMailsQuery, useSendMailMutation, useRetryMailMutation } = mailApi;

export default mailApi;
